/** MP5. 9 mm off a closed bolt: the most controllable automatic here, and the shortest reach. */

import type { WeaponSpec } from '@/sim/weapons/weaponContract';

export const MP5 = {
  id: 'mp5',
  label: 'MP5',
  classId: 'smg',
  caliber: '9x19 mm',
  fireMode: 'auto',
  roundsPerMinute: 800,
  magSize: 30,
  reserveAmmo: 180,
  reloadSeconds: 2,
  emptyReloadSeconds: 2.6,
  reloadStyle: 'magazine',
  damage: 22,
  damageTypeId: 'ballistic',
  falloff: { fullMetres: 20, zeroMetres: 100, minScale: 0.3 },
  pellets: 1,
  adsSpreadMoa: 7,
  hipSpreadMoa: 130,
  bloomMoaPerShot: 8,
  bloomMoaCap: 80,
  bloomDecayMoaPerSecond: 120,
  moveSpreadMoaPerMps: 18,
  crouchSpreadScale: 0.7,
  airborneSpreadMoa: 70,
  recoilPattern: [
    { pitch: 0.6, yaw: 0.04 },
    { pitch: 0.55, yaw: 0.14 },
    { pitch: 0.5, yaw: 0.24 },
    { pitch: 0.48, yaw: 0.26 },
    { pitch: 0.45, yaw: 0.12 },
    { pitch: 0.42, yaw: -0.08 },
    { pitch: 0.4, yaw: -0.22 },
    { pitch: 0.4, yaw: -0.3 },
    { pitch: 0.38, yaw: -0.18 },
    { pitch: 0.36, yaw: 0.02 },
  ],
  recoilResetSeconds: 0.25,
  recoilRecoveryPerSecond: 7,
  adsFovDegrees: 60,
  adsSeconds: 0.15,
  adsSensitivityScale: 0.8,
  muzzleVelocity: 400,
} as const satisfies WeaponSpec;
